export const vueLink = 'https://vuejs.org/';
export const npmLink = 'https://www.npmjs.com/';
export const yarnLink = 'https://yarnpkg.com/';
export const repoLink = 'https://github.com/gluons/vue-thailand-address';
export const jqTHLink = 'https://github.com/earthchie/jquery.Thailand.js';
